<template>
  <div class="permit-tracker">
    <breadcrumbs />
    <div 
      v-if="ready && status === 'search' && !this.detailInfo"
      class="column is-12 "
    >
      <div>
      Track the status of your L&I permit application. Check the
      <a class="has-text-weight-semibold" target="blank" href="https://admin.phila.gov/documents/li-permit-processing-times/">
        list of permit processing times 
      </a> to see the timeframe for applications to be reviewed.
      </div>
    </div>
    <div v-if="this.detailInfo" class="back is-link" @click="clearFilters()"> 
      <i class="fa fa-angle-left" aria-hidden="true"></i> 
      Back
    </div>
    <div
      v-if="!$route.query.Id"
    >
      <div 
        class="search-bar-app-tracker"
         v-if="ready"
      >
        <div
          class="columns"
        >
          <div
            class="column is-12 is-centered"
            v-if="!this.detailInfo"
          >
            <div class="has-text-weight-bold"> Type in your application number</div>
            <SearchBox
              class="appeal-calendar-search-box"
              v-model="searchInput"
              @searchclear="searchInput = '', clearFilters()"
              :placeholder="placeholder"
              :handleSearchFormSubmit="getPermitsApps"
            >
            </SearchBox>

            If you are the owner or authorized agent, and have questions about your application 
            status, you can 
              <a class="has-text-weight-semibold" target="blank" href="https://form.jotform.com/202434637485055">
                request additional information.
              </a>
          </div>
          <div 
            class="app-number"
            v-if="this.detailInfo"
          >
            <div class="permit-title has-text-weight-semibold">Permit application number</div>
            <div class="permit-number is-size-2">{{ this.detailInfo.APPLICATIONNUMBER }}</div>
          </div>
        </div>
      </div>
      <div
        v-show="status === 'loading'"
        class="columns is-centered"
      >
        <i class="fas fa-spinner fa-spin fa-3x" />
      </div>

      <div class="columns is-centered">
        <div 
          class="search-error search-bar-content"
          v-if="status === 'error'"
        >
          <p><span class="red">!</span> No results found for {{ searchInput }}. </p>
        </div> 
        <div
          v-if="status !== 'error' && this.detailInfo"
        >
          <v-client-table 
            class="table-light no-header column is-12 app-tracker"
            :data="tableData" 
            :columns="columns"
            :options="options"
          >
            <p slot="afterTable" class="after-table">
            If you have questions about your permit application status, you can
              <a class="has-text-weight-semibold" target="blank" href="https://form.jotform.com/202434637485055">
                request additional information.
              </a>
            </p>
          </v-client-table >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import SearchBox from '@/components/SearchBox';
import moment from 'moment-timezone';

export default {
  name: 'PermitApplicationTracker',
  props: {
    },
  data() {
    return {
      placeholder: "For example: XX-####-######",
      detailInfo: null,
      searchInput: null,
      search:"",
      status: 'search',
      ready: false,
      dropdown: [],
      emptyResponse: null,
      key: 0,
      columns: ['id','name'],
      options: {
        filterable: false,
        sortable: [],
        highlightMatches: false,
        perPageValues: [],
        headings: { 
          APPLICATIONDESCRIPTION: "Application Description", 
          STATUS: "Status", 
          COMMENTS: "Comments", 
          APPLICATIONDATE: "Application submission date", 
          LATESTREVIEWDUEDATE: "Due date of last review", 
          LATESTREVIEWCOMPLETEDDATE: "Date review completed", 
        },
        pagination: { 
          show: false, 
        },
        columnsClasses: {
          id: 'has-text-weight-bold',
          name: 'id',
        },
      },
      routerQuery: {},
    }
  },
  components: {
    SearchBox,
  },
  beforeCreate(){
    this.$store.commit('updateHeader', 'permitApplicationTracker');
  },
  async created(){
    if (this.status === 'search' && this.$route.query.appId) {
      this.searchInput = this.$route.query.appId
      try {
        if(typeof this.$route.query.Id  !== 'undefined') {
          await this.getPermitsApps(this.$route.query.Id);
        } else {
          await this.getPermitsApps()
        }
      } catch (err) {
        console.warn("Oops", err);
      } 
    } 
      return this.ready = true
  },
  destroyed(){
    this.$store.commit('updateHeader', null);
  },
    watch: {
      routerQuery: {
        handler: function () {
          this.updateRouter();
        },
        deep: true,
      },
  },
    computed: {
    tableData(){
      let permitApp = this.detailInfo ? this.detailInfo : null;
      let tableInfo = [];
      if(permitApp) {
        tableInfo = [
            { id: "Location", 
              name: permitApp.ADDRESS
            },
            { id: "Application Description", 
              name: permitApp.APPLICATIONDESCRIPTION
            },
            { id: "Status", 
              name: permitApp.STATUS
            },
            { id: "Comments", 
              name: permitApp.COMMENTS
            },
            { id: "Application submission date", 
              name: moment( permitApp.APPLICATIONDATE ).format('dddd, MMMM DD, YYYY')
            },
            { id: "Due date of last review", 
              name: moment( permitApp.LATESTREVIEWDUEDATE  ).format('dddd, MMMM DD, YYYY')
            },
            { id: "Date review completed", 
              name: moment( permitApp.LATESTREVIEWCOMPLETEDDATE ).format('dddd, MMMM DD, YYYY')
            },
        ]
      }
      return tableInfo;
    },
  },
  methods: {
    async getPermitsApps(detail) {
      this.emptyResponse = null;
      this.status !== 'search' ? this.clearFilters(): "";
      this.status = 'loading';
      try {
        await this.$store.dispatch('permitApplicationTracker/getPermitApps', this.searchInput);
        // console.log("set status");
        let urlQuery = detail && detail.Id === 'MouseEvent' ? { appId: this.searchInput , Id: detail} : { appId: this.searchInput}
        this.$router.push(
          { name: 'PermitApplicationTracker',
            query: urlQuery,
          }).catch(()=>{});
        this.status = 'results';
        this.checkEmptyReponse();
      } catch (err) {
        // console.log("Response errored: ", err);
          this.status = 'error';
          this.detailInfo = null;
      }
      return
    },
    checkEmptyReponse(){
      if (!this.status !== 'error') {
        this.$store.state.permitApplicationTracker.permitApps.length < 1 ? this.emptyResponse = this.searchInput : this.emptyResponse = null;
        if (this.emptyResponse) {
          this.status = 'error';
          // this.$router.push(
          //   { name: 'permit-search-error',
          //     query: { address: this.emptyResponse},
          //     params:  { appId: this.emptyResponse }
          //   }).catch(()=>{});
          return this.detailInfo = null;
        } else {
          return this.detailInfo = this.$store.state.permitApplicationTracker.permitApps[0];
        }
      }
    },
    clearFilters(){
        this.searchInput = null;
        this.status ='search';
        this.detailInfo = null;
        this.updateRouter();
    },
    dateFormat(date){
      // console.log(date, moment(date).isValid(), moment(date));
      if (moment(date).isValid()) {
        return moment(date).format('MMM DD, YYYY')
      }
      return date
    },
    updateRouterQuery: function (key, value) {
      if (!value) {
        this.$delete(this.routerQuery, key);
      } else {
        this.$set(this.routerQuery, key, value);
      }
    },
    updateRouter: function () {
      console.log("updateRouter: ", this.routerQuery, this.$route.query);
      if (this.routerQuery  === this.$route.query) {
        return;
      } 
      if(Object.values(this.routerQuery).length > 0) {
        this.$router.push({
          name: 'PermitApplicationTracker',
          query: this.routerQuery,
        }).catch(e => {
          window.console.log(e); 
          return
        });
      } else {
        this.$router.push({
          name: 'PermitApplicationTracker',
        }).catch(e => {
          window.console.log(e); 
        });
      }
    },
  },
};
</script>
<style lang="scss">
@media screen and (max-width: 768px) {
  #app > main {
      display: inline;
  }
  .search-bar {
    padding: 15px;
    div>div.is-10, div>div>form {
      margin: 0 15px 0 15px;
    }
  }
}

.app-tracker>div>table>tbody>tr:last-child {
    border-bottom: thin solid #a1a1a1;
}

.after-table {
  margin-top: 10px;
  padding-left: 10px;
}

.appeal-calendar-search-box>form.search-box-form>div.input-wrap>div>div>input {
  border: 2px solid $ben-franklin-blue-dark;
}


div.back.is-link:hover {
    background-color: transparent;
    border-color: unset;
    color: $grey-dark !important;
    cursor: pointer;
}

div.app-number {
  margin-left: 0 !important;
  margin-right: 0 !important;
}

div.columns#filters>div.unset-margin {
  margin: unset;
}

.no-header th {
  display: none !important;
}


</style>
<style lang="scss" scoped>

  .permit-tracker {
    margin-bottom: 40px;
  }
  
  .back {
    font-size: 0.9em;
    font-weight: 600;
    padding-top: 15px;
    padding-bottom: 10px;
    // margin-top: 1.25rem;
  }

  div.column>.input-wrap {
    padding: 0;
  }
  .detail {
    margin: auto;
  }

  .search-bar-app-tracker {
    display: flow-root;
    background-color: $ben-franklin-blue-light;
    padding: 25px 35px 25px 35px;
    &.columns {
      margin-top: 0;
      margin-bottom: 0;
    }
    .column {
      padding-top: 5px;
      padding-bottom:5px;
    }
  }
  .search-bar-content {
    margin-top: 50px;
    margin-bottom: 50px;
    text-align: center;
    h3 {
      color: #444444;
    }
    p {
    font-size: smaller;
    }
  }

  .red {
    color: #cc3000;
    font-size: 1.5rem;
  }

  .search-error {
    font-weight: bold;
    font-size: 1.25rem;
    margin-left: 45px !important;
  }

  .bottom-grey-header{
    background-color: $ghost-grey;
    bottom: 0;
    position: absolute;
    width: 100%;
    left: 0;
    text-align: center;
    padding: 25px;
    font-size: larger;
  }

  .left {
    float: left;
  }

.clear-filters {
  position: relative;
  top: 50%;
}

</style>
